/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { Theme } from '@modules/ui-types'
import { hasUnexpiredSession } from '@modules/auth/auth'

import { getTheme } from '@/reducers/theme'

import { bless } from '../../../lib/router'

import NotFound from './NotFound'

import type { ReduxState } from '@/types/redux'

type StateProps = {
  theme: Theme
  showLoginButton: boolean
  withHttpErrorPage?: boolean
}

interface DispatchProps {}

interface ConsumerProps {}

const mapStateToProps = (state: ReduxState): StateProps => ({
  theme: getTheme(state),
  showLoginButton: !hasUnexpiredSession(),
})

const mapDispatchToProps: DispatchProps = {}

export default bless(
  connect<StateProps, DispatchProps, ConsumerProps>(mapStateToProps, mapDispatchToProps)(NotFound),
)
